import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Bookmark } from "lucide-react";
import { toast } from "sonner";
import { useFaith } from "@/lib/useFaith";
import { Logo, LogoMark } from "@/components/lunelle/Logo";
import { DailyVerse, FaithPills } from "@/components/lunelle/DailyWord";

import { usePageMeta } from "@/lib/usePageMeta";

export default function TodayPage() {
  const [faith, setFaith] = useFaith();
  usePageMeta("Today's Word: Daily Scripture & Affirmation | Lunelle", "A new scripture or affirmation every morning for Christian, Muslim, Jewish, Hindu, Buddhist and spiritual paths. Pick your faith and bookmark your daily word.");

  useEffect(() => {
    window.history.replaceState(null, "", `/today?faith=${faith}`);
  }, [faith]);

  const bookmark = () => toast("Bookmark this page", { description: "Press Ctrl/Cmd + D, or use your browser's share menu on mobile. A new word appears every morning." });

  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden" data-testid="today-page">
      <div className="pointer-events-none absolute -left-40 top-20 h-[520px] w-[520px] rounded-full bg-[#F4DED3] blur-3xl" />
      <LogoMark className="pointer-events-none absolute -right-24 bottom-[-6rem] h-[420px] w-[420px] opacity-[0.07]" color="#9E4429" />
      <header className="relative mx-auto flex w-full max-w-7xl items-center justify-between px-5 py-6 sm:px-8 lg:px-12">
        <Link to="/" data-testid="today-page-home-link"><Logo /></Link>
        <Link to="/" data-testid="today-page-back-link" className="flex items-center gap-2 text-sm text-[#5C4A42] transition-colors hover:text-[#2C221E]">
          <ArrowLeft className="h-4 w-4" /> Back to Lunelle
        </Link>
      </header>
      <main className="relative mx-auto flex w-full max-w-5xl flex-1 flex-col justify-center px-5 py-16 sm:px-8">
        <DailyVerse faith={faith} size="xl" />
        <div className="mt-14 space-y-6 border-t border-[#C86D51]/20 pt-10">
          <FaithPills faith={faith} onChange={setFaith} prefix="today-page" />
          <div className="flex flex-wrap gap-3">
            <button onClick={bookmark} data-testid="today-page-bookmark-button"
              className="inline-flex items-center gap-2 rounded-full bg-[#2C221E] px-5 py-3 text-sm font-medium text-[#FBF5EE] transition-colors hover:bg-[#9E4429]">
              <Bookmark className="h-4 w-4" /> Bookmark this page
            </button>
            <Link to="/#waitlist" data-testid="today-page-waitlist-link"
              className="inline-flex items-center rounded-full border border-[#C86D51]/30 px-5 py-3 text-sm font-medium text-[#2C221E] transition-colors hover:border-[#9E4429]">
              Join the waitlist
            </Link>
          </div>
        </div>
      </main>
      <p className="relative px-5 pb-8 text-center text-xs text-[#6B5A52]">A new word appears every morning · Lunelle</p>
    </div>
  );
}
